<template>
  <footer class="bg-primary text-white pb-5 pt-5">
    <div class="container creditos">
      <div class="row">
        <div class="d-flex container-fluid">
          <div class="col-2 mr-auto p-0">
            <img src="@/assets/images/Logo-Kia.png" alt="KIA LOGO" class="imagen-pie bounceIn img-fluid">
          </div>
          <div class="col-2 ml-auto text-right">
            <img src="@/assets/app_logo.png" alt="" class="img-fluid app-logo">
          </div>
          <div class="col-2 col-md-1 col-lg-1 my-auto p-0">
            <a href="https://itunes.apple.com/ec/app/mi-kia-ecuador/id1372994852?l=en&mt=8" target="_blank">
              <img src="@/assets/logo_astore.png" alt="" class="img-fluid brand-logo">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.AekiaI.com" target="_blank">
              <img src="@/assets/logo_gplay.png" alt="" class="img-fluid brand-logo">
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <small class="col-12 pt-3 text-justify container">
          Se reserva el derecho de hacer cambios en cualquier momento sin previo aviso u obligación a la información
          contenida en este sitio de web, precios, programas de incentivos, especificaciones técnicas, equipamiento,
          ilustraciones y de modificar o suspender modelos y otros. Las imágenes y videos pueden no corresponder con el
          producto final. Algunas características del vehículo de la imagen no aplican a los modelos ensamblados o
          comercializados en Ecuador.
        </small>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>
